import { combineReducers } from "redux";
import tokenReducer from "./token";
import rideReducer from "./ride";

const rootReducer = combineReducers({
  token: tokenReducer,
  ride: rideReducer,
});

export default rootReducer;
